import { useEffect, useState, useContext, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SidebarContext } from "../../shared/context/SidebarContext";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { format } from "date-fns";
import api from "../../shared/services/api";
import {
    loadCampanhaDetalheService,
    loadGruposCampanhaService,
    loadGruposDisponiveisService,
    vincularGruposService,
    criarGrupoWAService,
    editarGruposMassaService,
    revalidarMembrosService,
    adicionarAdminService,
    desvincularGrupoService,
    sincronizarMembrosService,
    loadMensagensService,
    createMensagemService,
    updateMensagemService,
    deleteMensagemService,
    enviarMensagemService,
    loadAgendamentosService,
    createAgendamentoService,
    deleteAgendamentoService,
    loadSessoesService,
    loadLogsService,
    loadCampanhaSessoesService,
    salvarCampanhaSessoesService,
    removerCampanhaSessaoService,
    prepararSessoesService,
} from "./services/campanhasService";
import {
    ArrowLeft, Users, MessageSquare, Clock, Plus, Send, Trash2, Edit2, Calendar,
    Download, Check, Search, Settings, Upload, RefreshCw, Copy, ExternalLink, FileText, ChevronDown, ChevronUp, Loader2, UserPlus, Smartphone
} from "lucide-react";
import { getSocket, joinRoom, leaveRoom } from "../../shared/services/socket";

export default function WhatsAppCampanhaDetalhe() {
    const { id: campanhaId } = useParams();
    const navigate = useNavigate();
    const { isOpen } = useContext(SidebarContext);

    const [campanha, setCampanha] = useState(null);
    const [aba, setAba] = useState("grupos");
    const [grupos, setGrupos] = useState([]);
    const [mensagens, setMensagens] = useState([]);
    const [agendamentos, setAgendamentos] = useState([]);
    const [logs, setLogs] = useState([]);
    const [sessoes, setSessoes] = useState([]);
    // Subsessões da campanha (rotação multi-sessão): { total_grupos, subsessoes: [...] }
    const [campSessoes, setCampSessoes] = useState({ total_grupos: 0, subsessoes: [] });
    const [novaSubsessao, setNovaSubsessao] = useState("");
    const [loading, setLoading] = useState(true);
    const [sendingMsgId, setSendingMsgId] = useState(null);
    const [syncing, setSyncing] = useState(false);
    const [expandedLog, setExpandedLog] = useState(null);

    // Real-time: operação ativa cuja progress chega via Socket.IO.
    // formato: { logId, tipo: 'envio'|'ops', total, ok, erros, percent, status, finalizado }
    const [progressoAtivo, setProgressoAtivo] = useState(null);

    // Modais
    const [modalGrupo, setModalGrupo] = useState(false);
    const [modalImportar, setModalImportar] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [modalAgenda, setModalAgenda] = useState(false);
    const [editandoMsg, setEditandoMsg] = useState(null);
    const [modalBulkEdit, setModalBulkEdit] = useState(false);

    // Import state
    const [gruposDisponiveis, setGruposDisponiveis] = useState([]);
    const [gruposSelecionados, setGruposSelecionados] = useState([]);
    const [buscaGrupo, setBuscaGrupo] = useState("");
    const [loadingImport, setLoadingImport] = useState(false);

    // Bulk edit state
    const [bulkForm, setBulkForm] = useState({ subject: "", description: "", imageUrl: "", revalidar: false, numeroInicial: 1 });
    const [bulkUploading, setBulkUploading] = useState(false);
    const bulkFileRef = useRef(null);
    const mediaFileRef = useRef(null);
    const [mediaUploading, setMediaUploading] = useState(false);
    const [bulkLoading, setBulkLoading] = useState(false);

    // Forms
    const [grupoNome, setGrupoNome] = useState("");
    const [grupoQtd, setGrupoQtd] = useState(1);
    const [grupoNumInicial, setGrupoNumInicial] = useState(1);
    const [msgForm, setMsgForm] = useState({ titulo: "", tipo: "texto", conteudo: "", media_url: "", mencao_todos: false, global: false, pollQuestion: "", pollOptions: "" });
    const [agendaForm, setAgendaForm] = useState({ mensagem_id: "", data_hora: "", grupos_alvo: [] });

    const carregar = async () => {
        setLoading(true);
        try {
            const [c, g, m, a, s, l, cs] = await Promise.all([
                loadCampanhaDetalheService(campanhaId),
                loadGruposCampanhaService(campanhaId),
                loadMensagensService(campanhaId),
                loadAgendamentosService(campanhaId),
                loadSessoesService(),
                loadLogsService(campanhaId).catch(() => []),
                loadCampanhaSessoesService(campanhaId).catch(() => ({ total_grupos: 0, subsessoes: [] })),
            ]);
            setCampanha(c);
            setGrupos(g);
            setMensagens(m);
            setAgendamentos(a);
            setSessoes(s.filter(ss => ss.status === "conectado" || ss.status === "open"));
            setLogs(l);
            setCampSessoes(cs);
        } catch (err) {
            console.error("Erro ao carregar:", err);
            toast.error("Erro ao carregar dados da campanha");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { carregar(); }, [campanhaId]);

    // Subscreve no Socket.IO quando uma operação ativa (envio ou ops) é iniciada.
    // O worker emite eventos `envio:progress` na room `envio-${logId}` e
    // `ops:progress` na room `ops-${logId}`. Quando `finalizado: true` chega,
    // recarrega os dados da página e fecha o banner após 2s.
    useEffect(() => {
        if (!progressoAtivo?.logId) return;
        const { logId, tipo } = progressoAtivo;
        const evt = tipo === "envio" ? "envio:progress" : "ops:progress";
        const socket = getSocket();

        // setTimeouts agendados (recarga pós-finalização) que precisam ser
        // cancelados no cleanup pra não dispararem carregar()/setProgressoAtivo
        // após o efeito desmontar ou re-rodar.
        const timeoutIds = [];

        joinRoom(tipo, logId);
        const handler = (data) => {
            if (!data || data.logId !== logId) return;
            setProgressoAtivo((prev) => (prev && prev.logId === data.logId ? { ...prev, ...data } : prev));
            if (data.finalizado) {
                timeoutIds.push(setTimeout(() => {
                    carregar();
                    setProgressoAtivo(null);
                }, 2000));
            }
        };
        socket.on(evt, handler);

        // Fallback: poll logs every 3 seconds to catch if it finished but we missed the socket event
        const interval = setInterval(async () => {
            try {
                const recentLogs = await loadLogsService(campanhaId);
                const activeLog = recentLogs.find(l => l.id === logId);
                if (activeLog && (activeLog.status === 'concluido' || activeLog.status === 'erro' || activeLog.status === 'parcial')) {
                    // Para o interval imediatamente: sem isso ele reentraria antes
                    // do setTimeout limpar o state e dispararia carregar() duplicado.
                    clearInterval(interval);
                    setProgressoAtivo(prev => prev && prev.logId === logId ? {
                        ...prev,
                        ok: activeLog.ok,
                        erros: activeLog.erros,
                        percent: 100,
                        finalizado: true,
                        status: activeLog.status
                    } : prev);

                    timeoutIds.push(setTimeout(() => {
                        carregar();
                        setProgressoAtivo(null);
                    }, 2000));
                } else if (activeLog && activeLog.status === 'processando') {
                    // Update progress from DB if available
                    setProgressoAtivo(prev => prev && prev.logId === logId ? {
                        ...prev,
                        ok: activeLog.ok,
                        erros: activeLog.erros,
                        percent: Math.round(((activeLog.ok + activeLog.erros) / (activeLog.total || 1)) * 100)
                    } : prev);
                }
            } catch (err) {
                console.error("Erro no polling de fallback:", err);
            }
        }, 3000);

        return () => {
            clearInterval(interval);
            timeoutIds.forEach(clearTimeout);
            socket.off(evt, handler);
            leaveRoom(tipo, logId);
        };
        // Deps intencionalmente limitadas a logId/tipo: o efeito (re)inscreve a
        // room/socket por operação ativa. `campanhaId` vem da rota e é estável
        // durante a vida da página; `carregar` é recriado a cada render — incluí-lo
        // re-rodaria o efeito a cada render, derrubando/refazendo a inscrição socket
        // e reiniciando o interval sem necessidade. Ambos são lidos por closure e
        // suas referências atuais bastam aqui.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [progressoAtivo?.logId, progressoAtivo?.tipo]);

    const sessionName = campanha?.session_name || sessoes[0]?.session_name || "";
    // `sessoes` só contém sessões conectadas; se a sessão da campanha estiver
    // desconectada ela não aparece e não dá pra confirmar o provider. Nesse caso
    // fica null e o chip omite o sufixo " · provider" em vez de mentir "whatsmeow".
    const sessionProvider = sessoes.find((s) => s.session_name === sessionName)?.provider || null;

    // === CRIAR GRUPO(S) WA (usa config da campanha) ===
    const criarGrupo = async () => {
        if (!grupoNome.trim()) { toast.warn("Preencha o nome do grupo"); return; }
        if (!sessionName) { toast.warn("Nenhuma sessão disponível"); return; }
        const qtd = Math.max(parseInt(grupoQtd) || 1, 1);
        const numIni = Math.max(parseInt(grupoNumInicial) || 1, 1);
        setModalGrupo(false);
        Swal.fire({
            title: 'Enviando solicitação...',
            allowOutsideClick: false, allowEscapeKey: false, showConfirmButton: false,
            didOpen: () => Swal.showLoading(),
        });
        try {
            const result = await criarGrupoWAService(campanhaId, {
                nomeGrupo: grupoNome,
                descricao: campanha?.descricao || null,
                fotoUrl: campanha?.imagem_url || null,
                participantes: [
                    ...(campanha?.admins || []),
                    ...(campanha?.espioes || []),
                ],
                admins: campanha?.admins || [],
                sessionName,
                quantidade: qtd,
                numeroInicial: numIni,
            });
            Swal.close();
            if (result?.status === 'processing' && result?.logId) {
                setProgressoAtivo({
                    logId: result.logId,
                    tipo: 'ops',
                    total: result.total || qtd,
                    ok: 0,
                    erros: 0,
                    percent: 0,
                });
                toast.success(qtd > 1 ? `Criando ${qtd} grupos em segundo plano` : 'Criando grupo em segundo plano');
            } else {
                toast.success('Grupo(s) criado(s)');
                carregar();
            }
            setGrupoNome("");
            setGrupoQtd(1);
            setGrupoNumInicial(1);
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro ao criar grupo(s)', text: err.response?.data?.error || err.message });
        }
    };

    // === IMPORTAR GRUPOS ===
    const abrirImportar = async () => {
        if (!sessionName) { toast.warn("Nenhuma sessão disponível"); return; }
        setGruposSelecionados([]);
        setBuscaGrupo("");
        Swal.fire({
            title: 'Carregando grupos...',
            html: '<p class="text-sm">Buscando grupos do WhatsApp via API.</p><p class="text-xs text-gray-400 mt-2">Isso pode levar alguns minutos dependendo da quantidade de grupos.</p>',
            allowOutsideClick: false, allowEscapeKey: false, showConfirmButton: false,
            didOpen: () => Swal.showLoading(),
        });
        try {
            const disp = await loadGruposDisponiveisService(campanhaId, sessionName);
            setGruposDisponiveis(disp);
            Swal.close();
            setModalImportar(true);
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro ao buscar grupos', text: err.response?.data?.error || err.message });
            setGruposDisponiveis([]);
        }
    };

    const toggleSelection = (jid) => {
        setGruposSelecionados(prev =>
            prev.includes(jid) ? prev.filter(j => j !== jid) : [...prev, jid]
        );
    };

    const importarGrupos = async () => {
        if (gruposSelecionados.length === 0) { toast.warn("Selecione pelo menos 1 grupo"); return; }
        const total = gruposSelecionados.length;
        setModalImportar(false);
        Swal.fire({
            title: 'Importando grupos...',
            html: `<p class="text-sm">Vinculando <b>${total}</b> grupo(s) à campanha.</p><p class="text-xs text-gray-400 mt-2">Buscando links de convite... Pode levar ~${total * 3}s.</p>`,
            allowOutsideClick: false, allowEscapeKey: false, showConfirmButton: false,
            didOpen: () => Swal.showLoading(),
        });
        try {
            const gruposParaImportar = gruposDisponiveis
                .filter(g => gruposSelecionados.includes(g.grupo_jid))
                .map(g => ({
                    grupo_jid: g.grupo_jid,
                    nome_grupo: g.nome_grupo,
                    total_membros: g.total_membros,
                }));
            await vincularGruposService(campanhaId, gruposParaImportar, sessionName);
            Swal.fire({ icon: 'success', title: 'Grupos importados!', text: `${total} grupo(s) vinculado(s) com sucesso.`, timer: 2500, showConfirmButton: false });
            carregar();
        } catch {
            Swal.fire({ icon: 'error', title: 'Erro ao importar', text: 'Tente novamente.' });
        }
    };

    const gruposFiltrados = gruposDisponiveis.filter(g =>
        g.nome_grupo.toLowerCase().includes(buscaGrupo.toLowerCase())
    );

    // === UPLOAD HELPER ===
    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        const res = await api.post("/upload", formData);
        return res.data.url;
    };

    // === EDIÇÃO EM MASSA ===
    const abrirBulkEdit = () => {
        setBulkForm({
            subject: "",
            description: campanha?.descricao || "",
            imageUrl: campanha?.imagem_url || "",
            revalidar: false,
            numeroInicial: 1,
        });
        setModalBulkEdit(true);
    };

    const handleBulkPhotoUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) { toast.warn('Selecione uma imagem'); return; }
        setBulkUploading(true);
        try {
            const url = await uploadFile(file);
            setBulkForm(prev => ({ ...prev, imageUrl: url }));
            toast.success('Foto enviada!');
        } catch { toast.error('Erro ao enviar foto'); }
        finally { setBulkUploading(false); }
    };

    const handleMediaUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const isVideo = msgForm.tipo === 'video';
        const isAudio = msgForm.tipo === 'audio';
        if (isVideo && file.size > 200 * 1024 * 1024) {
            toast.error(`Vídeo excede o limite de 200MB (${(file.size / 1024 / 1024).toFixed(1)}MB)`);
            return;
        }
        if (isAudio && file.size > 16 * 1024 * 1024) {
            toast.error(`Áudio excede 16MB (${(file.size / 1024 / 1024).toFixed(1)}MB)`);
            return;
        }
        if (isAudio && !file.type.startsWith('audio/')) { toast.warn('Selecione um arquivo de áudio'); return; }
        if (!isVideo && !isAudio && !file.type.startsWith('image/')) { toast.warn('Selecione uma imagem'); return; }
        setMediaUploading(true);
        try {
            const url = await uploadFile(file);
            setMsgForm(prev => ({ ...prev, media_url: url }));
            const msg = isVideo && file.size > 30 * 1024 * 1024 
                ? 'Vídeo enviado e comprimido com sucesso!' 
                : isVideo ? 'Vídeo enviado!' : isAudio ? 'Áudio enviado!' : 'Imagem enviada!';
            toast.success(msg);
        } catch (err) {
            const msg = err.response?.data?.error || err.message || 'Erro desconhecido';
            toast.error('Erro ao enviar: ' + msg);
        }
        finally { setMediaUploading(false); }
    };

    const executarBulkEdit = async () => {
        if (!bulkForm.subject && !bulkForm.description && !bulkForm.imageUrl && !bulkForm.revalidar) {
            toast.warn('Preencha pelo menos um campo ou marque revalidar');
            return;
        }
        if (!sessionName) { toast.warn('Nenhuma sessão disponível'); return; }
        setModalBulkEdit(false);
        const totalGrupos = grupos.length;
        Swal.fire({
            title: 'Enviando solicitação...',
            allowOutsideClick: false, allowEscapeKey: false, showConfirmButton: false,
            didOpen: () => Swal.showLoading(),
        });
        try {
            const msgs = [];
            // Última operação processing com logId vira o progresso ativo.
            let opAtiva = null;

            // 1. Editar grupos (se houver campos preenchidos)
            if (bulkForm.subject || bulkForm.description || bulkForm.imageUrl) {
                const payload = { sessionName };
                if (bulkForm.subject.trim()) payload.subject = bulkForm.subject;
                if (bulkForm.description.trim()) payload.description = bulkForm.description;
                if (bulkForm.imageUrl.trim()) payload.imageUrl = bulkForm.imageUrl;
                payload.numeroInicial = bulkForm.numeroInicial || 1;

                const res = await editarGruposMassaService(campanhaId, payload);
                msgs.push(`${res.total} grupo(s) sendo editados`);
                if (res?.status === 'processing' && res?.logId) {
                    opAtiva = { logId: res.logId, total: res.total || totalGrupos };
                }
            }

            // 2. Revalidar admins/espiões
            if (bulkForm.revalidar) {
                const res = await revalidarMembrosService(campanhaId, sessionName);
                if (res.status === 'processing') {
                    msgs.push(`revalidando admins/espiões em ${res.total} grupo(s)`);
                    // Revalidação tem prioridade no banner (substitui edição).
                    if (res?.logId) opAtiva = { logId: res.logId, total: res.total || totalGrupos };
                } else {
                    msgs.push(`admins/espiões OK em ${res.total} grupo(s)`);
                }
            }

            Swal.close();
            if (opAtiva) {
                setProgressoAtivo({
                    logId: opAtiva.logId,
                    tipo: 'ops',
                    total: opAtiva.total,
                    ok: 0,
                    erros: 0,
                    percent: 0,
                });
                toast.info(`Processando: ${msgs.join(' · ')}`);
            } else {
                toast.success(msgs.join(' · ') || 'Operação concluída');
                carregar();
            }
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro na edição em massa', text: err.response?.data?.error || err.message });
        }
    };

    // === ADICIONAR ADMIN EM TODOS OS GRUPOS ===
    // Adiciona o número como participante (se já estiver, só promove) e promove
    // a admin em todos os grupos — op em background com pausa entre grupos
    // (reusa o handler de revalidação no backend).
    const adicionarAdmin = async () => {
        const { value: numero } = await Swal.fire({
            title: 'Adicionar Admin',
            input: 'text',
            inputLabel: 'Número com DDD (ex: 5511999998888)',
            inputPlaceholder: '5511999998888',
            html: `<p class="text-xs text-gray-400">O número será adicionado como participante (se ainda não estiver no grupo) e promovido a admin em <b>${grupos.length}</b> grupo(s), com pausa entre grupos pra evitar bloqueio.</p>`,
            showCancelButton: true,
            confirmButtonText: 'Adicionar em Todos',
            cancelButtonText: 'Cancelar',
            inputValidator: (v) => {
                const d = String(v || '').replace(/\D/g, '');
                if (d.length < 10) return 'Número inválido — informe DDD + número';
                return null;
            },
        });
        if (!numero) return;
        try {
            const res = await adicionarAdminService(campanhaId, numero);
            if (res.status === 'processing' && res.logId) {
                setProgressoAtivo({
                    logId: res.logId,
                    tipo: 'ops',
                    total: res.total,
                    ok: 0,
                    erros: 0,
                    percent: 0,
                });
                toast.success(`Adicionando ${res.numero} como admin em ${res.total} grupo(s) em segundo plano`);
            }
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro ao adicionar admin', text: err.response?.data?.error || err.message });
        }
    };

    // === MENSAGENS ===
    const salvarMsg = async () => {
        if (!msgForm.titulo.trim()) { toast.warn("Preencha o título"); return; }
        try {
            const payload = {
                campanha_id: campanhaId,
                titulo: msgForm.titulo,
                tipo: msgForm.tipo,
                conteudo: msgForm.conteudo,
                media_url: msgForm.tipo !== "texto" && msgForm.tipo !== "enquete" ? msgForm.media_url : null,
                mencao_todos: msgForm.mencao_todos,
                global: msgForm.global,
                opcoes_enquete: msgForm.tipo === "enquete" ? {
                    question: msgForm.pollQuestion,
                    options: msgForm.pollOptions.split(",").map(o => o.trim()).filter(Boolean)
                } : null,
            };
            if (editandoMsg) {
                await updateMensagemService(editandoMsg.id, payload);
                toast.success("Mensagem atualizada!");
            } else {
                await createMensagemService(payload);
                toast.success("Mensagem criada!");
            }
            setModalMsg(false);
            setEditandoMsg(null);
            setMsgForm({ titulo: "", tipo: "texto", conteudo: "", media_url: "", mencao_todos: false, global: false, pollQuestion: "", pollOptions: "" });
            carregar();
        } catch {
            toast.error("Erro ao salvar mensagem");
        }
    };

    const enviarMsg = async (msg) => {
        if (!sessionName) { toast.warn("Nenhuma sessão conectada"); return; }
        if (sendingMsgId) { toast.warn("Já existe um envio em andamento"); return; }

        // Estimativa considera a rotação: subsessões conectadas e com pelo menos
        // um grupo pronto dividem o tempo total com a principal.
        const sessoesRotacao = 1 + campSessoes.subsessoes.filter(
            s => (s.sessao_status === "conectado" || s.sessao_status === "open") && s.grupos_admin > 0
        ).length;

        // 1. Selecionar grupos
        const gruposList = grupos.map(g => ({
            jid: g.grupo_jid,
            nome: g.nome_grupo,
            checked: true,
        }));

        const { isConfirmed, value: selectedJids } = await Swal.fire({
            title: 'Selecionar grupos',
            html: `
                <div style="text-align:left;max-height:350px;overflow-y:auto;margin-top:8px;">
                    <label style="display:flex;align-items:center;gap:8px;padding:6px 0;border-bottom:1px solid #333;margin-bottom:8px;cursor:pointer;">
                        <input type="checkbox" id="swal-toggle-all" checked style="accent-color:#10b981;width:16px;height:16px;">
                        <span style="font-weight:600;font-size:13px;">Selecionar todos (${gruposList.length})</span>
                    </label>
                    ${gruposList.map((g, i) => `
                        <label style="display:flex;align-items:center;gap:8px;padding:4px 0;cursor:pointer;">
                            <input type="checkbox" class="swal-grupo-cb" data-jid="${g.jid}" checked style="accent-color:#10b981;width:14px;height:14px;">
                            <span style="font-size:12px;">${g.nome}</span>
                        </label>
                    `).join('')}
                </div>
                <p id="swal-count" style="font-size:11px;color:#888;margin-top:8px;">${gruposList.length} grupo(s) selecionado(s) · ~${Math.ceil(gruposList.length * 40 / 60 / sessoesRotacao)} min${sessoesRotacao > 1 ? ` · rotacionando ${sessoesRotacao} sessões` : ''}</p>
            `,
            didOpen: () => {
                const toggleAll = document.getElementById('swal-toggle-all');
                const cbs = document.querySelectorAll('.swal-grupo-cb');
                const countEl = document.getElementById('swal-count');
                const updateCount = () => {
                    const checked = document.querySelectorAll('.swal-grupo-cb:checked').length;
                    countEl.textContent = `${checked} grupo(s) selecionado(s) · ~${Math.ceil(checked * 40 / 60 / sessoesRotacao)} min${sessoesRotacao > 1 ? ` · rotacionando ${sessoesRotacao} sessões` : ''}`;
                };
                toggleAll.addEventListener('change', () => {
                    cbs.forEach(cb => cb.checked = toggleAll.checked);
                    updateCount();
                });
                cbs.forEach(cb => cb.addEventListener('change', () => {
                    toggleAll.checked = document.querySelectorAll('.swal-grupo-cb:checked').length === cbs.length;
                    updateCount();
                }));
            },
            preConfirm: () => {
                const selected = [...document.querySelectorAll('.swal-grupo-cb:checked')].map(cb => cb.dataset.jid);
                if (selected.length === 0) { Swal.showValidationMessage('Selecione ao menos 1 grupo'); return false; }
                return selected;
            },
            showCancelButton: true,
            confirmButtonColor: '#10b981',
            confirmButtonText: `📨 Enviar "${msg.titulo}"`,
            cancelButtonText: 'Cancelar',
            width: 450,
        });

        if (!isConfirmed) return;

        const totalGrupos = selectedJids.length;
        setSendingMsgId(msg.id);
        try {
            const result = await enviarMensagemService(msg.id, {
                sessionName,
                mencao_todos: msg.mencao_todos,
                gruposAlvo: selectedJids,
                campanhaAlvoId: campanhaId,
            });
            if (result.status === 'processing' && result.logId) {
                setProgressoAtivo({
                    logId: result.logId,
                    tipo: 'envio',
                    total: result.total || totalGrupos,
                    ok: 0,
                    erros: 0,
                    percent: 0,
                });
                toast.success(`Enviando "${msg.titulo}" para ${totalGrupos} grupo(s)`);
            } else {
                toast.success('Mensagem enviada!');
                carregar();
            }
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro ao enviar', text: err.response?.data?.error || err.message || 'Tente novamente.' });
        } finally {
            setSendingMsgId(null);
        }
    };

    const editarMsg = (msg) => {
        setEditandoMsg(msg);
        setMsgForm({
            titulo: msg.titulo,
            tipo: msg.tipo,
            conteudo: msg.conteudo || "",
            media_url: msg.media_url || "",
            mencao_todos: msg.mencao_todos,
            global: msg.global,
            pollQuestion: msg.opcoes_enquete?.question || "",
            pollOptions: (msg.opcoes_enquete?.options || []).join(", "),
        });
        setModalMsg(true);
    };

    // === AGENDAMENTOS ===
    const agendar = async () => {
        if (!agendaForm.mensagem_id || !agendaForm.data_hora) { toast.warn("Preencha todos os campos"); return; }
        const gruposSelecionados = agendaForm.grupos_alvo.length > 0 ? agendaForm.grupos_alvo : grupos.map(g => g.grupo_jid);
        try {
            await createAgendamentoService({
                campanha_id: campanhaId,
                mensagem_id: agendaForm.mensagem_id,
                data_hora: agendaForm.data_hora,
                grupos_alvo: gruposSelecionados,
            });
            toast.success("Agendamento criado!");
            setModalAgenda(false);
            setAgendaForm({ mensagem_id: "", data_hora: "", grupos_alvo: [] });
            carregar();
        } catch {
            toast.error("Erro ao agendar");
        }
    };

    // === SUBSESSÕES (rotação multi-sessão) ===
    const adicionarSubsessao = async () => {
        if (!novaSubsessao) { toast.warn("Selecione uma sessão"); return; }
        try {
            const atuais = campSessoes.subsessoes.map(s => s.session_name);
            await salvarCampanhaSessoesService(campanhaId, [...atuais, novaSubsessao]);
            toast.success(`Subsessão "${novaSubsessao}" adicionada. Rode "Preparar Subsessões" para ela virar admin nos grupos.`);
            setNovaSubsessao("");
            const cs = await loadCampanhaSessoesService(campanhaId);
            setCampSessoes(cs);
        } catch (err) {
            toast.error(err.response?.data?.error || "Erro ao adicionar subsessão");
        }
    };

    const removerSubsessao = async (sn) => {
        const confirm = await Swal.fire({
            title: 'Remover subsessão?',
            text: `"${sn}" sai da rotação de envio. Ela continua admin nos grupos onde já foi preparada.`,
            icon: 'warning', showCancelButton: true,
            confirmButtonColor: '#ef4444', confirmButtonText: 'Remover',
            cancelButtonText: 'Cancelar',
        });
        if (!confirm.isConfirmed) return;
        try {
            await removerCampanhaSessaoService(campanhaId, sn);
            toast.success(`"${sn}" removida da rotação`);
            const cs = await loadCampanhaSessoesService(campanhaId);
            setCampSessoes(cs);
        } catch (err) {
            toast.error(err.response?.data?.error || "Erro ao remover subsessão");
        }
    };

    const prepararSubsessoes = async () => {
        const pendentesTotal = campSessoes.subsessoes.reduce(
            (acc, s) => acc + Math.max(0, campSessoes.total_grupos - s.grupos_admin), 0
        );
        const confirm = await Swal.fire({
            title: 'Preparar subsessões?',
            html: `<p class="text-sm">A sessão principal vai adicionar <b>${campSessoes.subsessoes.length}</b> subsessão(ões) como <b>admin</b> em até <b>${campSessoes.total_grupos}</b> grupo(s) (~${pendentesTotal} operações pendentes).</p>
                   <p class="text-xs text-gray-400 mt-2">O ritmo é propositalmente LENTO (gap de ~2 min entre grupos) pra evitar bloqueio. Pode levar horas — roda em segundo plano e é retomável.</p>`,
            icon: 'info', showCancelButton: true,
            confirmButtonColor: '#10b981', confirmButtonText: 'Iniciar Preparação',
            cancelButtonText: 'Cancelar',
        });
        if (!confirm.isConfirmed) return;
        try {
            const res = await prepararSessoesService(campanhaId);
            if (res.status === 'processing' && res.logId) {
                setProgressoAtivo({
                    logId: res.logId,
                    tipo: 'ops',
                    total: res.total,
                    ok: 0,
                    erros: 0,
                    percent: 0,
                });
                toast.success('Preparação iniciada em segundo plano (ritmo lento anti-ban)');
            }
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Erro ao preparar subsessões', text: err.response?.data?.error || err.message });
        }
    };

    const abas = [
        { key: "grupos", label: "Grupos", icon: Users, count: grupos.length },
        { key: "sessoes", label: "Sessões", icon: Smartphone, count: 1 + campSessoes.subsessoes.length },
        { key: "mensagens", label: "Mensagens", icon: MessageSquare, count: mensagens.length },
        { key: "agendamentos", label: "Agendamentos", icon: Clock, count: agendamentos.length },
        { key: "logs", label: "Logs", icon: FileText, count: logs.length },
    ];

    if (loading) {
        return (
            <main className={`transition-all duration-300 ${isOpen ? "lg:ml-64" : "sm:ml-16"} p-6 min-h-screen bg-base text-white flex items-center justify-center`}>
                <div className="animate-spin h-8 w-8 border-2 border-emerald-500 border-t-transparent rounded-full" />
            </main>
        );
    }

    return (
        <main className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto min-h-screen text-ink-1 mb-16 sm:mb-0`}>

            <header className="flex items-center gap-4 mb-6 animate-fade-in">
                <button onClick={() => navigate("/whatsapp/campanhas")} className="btn-ghost !p-2.5">
                    <ArrowLeft className="h-4 w-4" />
                </button>
                <div className="flex items-center gap-3 flex-1 min-w-0">
                    {campanha?.imagem_url && (
                        <img src={campanha.imagem_url} alt="" className="h-12 w-12 rounded-xl object-cover ring-1 ring-white/[0.08]" />
                    )}
                    <div className="min-w-0">
                        <h1 className="display-2 truncate">{campanha?.titulo || "Campanha"}</h1>
                        <div className="flex items-center gap-2 mt-1 flex-wrap">
                            {campanha?.tipo && <span className="chip-brand">{campanha.tipo}</span>}
                            {campanha?.session_name && <span className="chip-neutral">{campanha.session_name}{sessionProvider ? ` · ${sessionProvider}` : ""}</span>}
                            {campSessoes.subsessoes.length > 0 && (
                                <span className="chip-brand" title="Subsessões na rotação de envio">
                                    +{campSessoes.subsessoes.length} sessõe{campSessoes.subsessoes.length > 1 ? "s" : ""} em rotação
                                </span>
                            )}
                            {campanha?.limite_membros && <span className="text-xs text-ink-4 tabular-nums">Limite {campanha.limite_membros}/grupo</span>}
                        </div>
                    </div>
                </div>
            </header>

            {/* Banner de progresso real-time (Socket.IO) */}
            {progressoAtivo && !progressoAtivo.finalizado && (
                <div className="bg-positive-500/10 border border-positive-500/30 rounded-lg p-3 mb-4 flex items-center gap-3 animate-fade-in">
                    <Loader2 className="animate-spin text-positive-400 w-4 h-4 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                        <p className="text-sm text-positive-400 font-medium">
                            {progressoAtivo.tipo === 'envio' ? 'Enviando mensagem' : 'Processando operação'}
                            {' '}({progressoAtivo.ok || 0} ok · {progressoAtivo.erros || 0} erros · {progressoAtivo.total} total)
                        </p>
                        <div className="w-full bg-surface-2 rounded-full h-1.5 mt-1 overflow-hidden">
                            <div
                                className="bg-positive-500 h-full rounded-full transition-all duration-300"
                                style={{ width: `${progressoAtivo.percent || 0}%` }}
                            />
                        </div>
                    </div>
                    <span className="text-sm text-positive-400 tabular-nums">{progressoAtivo.percent || 0}%</span>
                </div>
            )}

            {/* Config summary */}
            {(campanha?.admins?.length > 0 || campanha?.espioes?.length > 0) && (
                <div className="bg-surface-1/50 border border-white/[0.06] rounded-lg p-3 mb-4 text-xs text-ink-3 flex flex-wrap gap-4">
                    {campanha.admins?.length > 0 && (
                        <span>👑 Admins: {campanha.admins.join(", ")}</span>
                    )}
                    {campanha.espioes?.length > 0 && (
                        <span>👁 Espiões: {campanha.espioes.join(", ")}</span>
                    )}
                </div>
            )}

            {/* Public Link */}
            {campanha?.slug && (
                <div className="bg-emerald-900/20 border border-emerald-800 rounded-lg p-3 mb-4 flex items-center gap-3">
                    <ExternalLink size={16} className="text-emerald-400 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                        <p className="text-xs text-emerald-400 font-medium">Link de Rotação de Grupos</p>
                        <p className="text-sm text-ink-2 truncate">{`${import.meta.env.VITE_ROTATION_DOMAIN || window.location.origin}/g/${campanha.slug}`}</p>
                    </div>
                    <button
                        onClick={() => {
                            navigator.clipboard.writeText(`${import.meta.env.VITE_ROTATION_DOMAIN || window.location.origin}/g/${campanha.slug}`);
                            toast.success("Link copiado!");
                        }}
                        className="flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 px-3 py-1.5 rounded-lg text-xs font-medium transition flex-shrink-0">
                        <Copy size={12} /> Copiar
                    </button>
                </div>
            )}

            {/* Tabs */}
            <div className="flex gap-1 mb-6 bg-surface-1 rounded-lg p-1 w-fit">
                {abas.map((a) => (
                    <button
                        key={a.key}
                        onClick={() => setAba(a.key)}
                        className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition ${aba === a.key ? "bg-emerald-600 text-white" : "text-ink-3 hover:text-white hover:bg-surface-2"
                            }`}
                    >
                        <a.icon size={14} />
                        {a.label}
                        <span className={`ml-1 text-xs px-1.5 py-0.5 rounded-full ${aba === a.key ? "bg-emerald-700" : "bg-surface-2"}`}>
                            {a.count}
                        </span>
                    </button>
                ))}
            </div>

            {/* === ABA GRUPOS === */}
            {aba === "grupos" && (
                <div>
                    <div className="flex flex-wrap justify-between items-center gap-2 mb-4">
                        <h2 className="text-lg font-semibold">Grupos vinculados</h2>
                        <div className="flex gap-2">
                            {grupos.length > 0 && (
                                <button onClick={abrirBulkEdit} className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700 px-3 py-2 rounded-lg text-sm transition">
                                    <Settings size={14} /> Editar em Massa
                                </button>
                            )}
                            <button onClick={abrirImportar} className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 px-3 py-2 rounded-lg text-sm transition">
                                <Download size={14} /> Importar Grupos
                            </button>
                            <button
                                onClick={async () => {
                                    setSyncing(true);
                                    Swal.fire({
                                        title: 'Sincronizando membros...',
                                        html: `<p class="text-sm">Atualizando contagem de membros de <b>${grupos.length}</b> grupo(s).</p><p class="text-xs text-gray-400 mt-2">Buscando participantes e links de convite via API...</p>`,
                                        allowOutsideClick: false, allowEscapeKey: false, showConfirmButton: false,
                                        didOpen: () => Swal.showLoading(),
                                    });
                                    try {
                                        const result = await sincronizarMembrosService(campanhaId);
                                        Swal.close();
                                        if (result.status === 'processing' && result.logId) {
                                            setProgressoAtivo({
                                                logId: result.logId,
                                                tipo: 'ops',
                                                total: result.total,
                                                ok: 0,
                                                erros: 0,
                                                percent: 0,
                                            });
                                            toast.success(`Sincronizando ${result.total} grupo(s) em segundo plano`);
                                        } else {
                                            const ok = result.resultados?.filter(r => r.ok).length || 0;
                                            const erros = result.resultados?.filter(r => !r.ok).length || 0;
                                            if (erros) toast.warn(`${ok} grupo(s) atualizados · ${erros} erro(s)`);
                                            else toast.success(`${ok} grupo(s) atualizados`);
                                            carregar();
                                        }
                                    } catch {
                                        Swal.fire({ icon: 'error', title: 'Erro ao sincronizar', text: 'Tente novamente.' });
                                    } finally { setSyncing(false); }
                                }}
                                disabled={syncing}
                                className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700 px-3 py-2 rounded-lg text-sm transition disabled:opacity-50"
                                title="Atualizar contagem de membros via API">
                                <RefreshCw size={14} className={syncing ? 'animate-spin' : ''} />
                                {syncing ? 'Sincronizando...' : 'Sincronizar'}
                            </button>
                            <button onClick={adicionarAdmin}
                                className="flex items-center gap-2 bg-brand-600 hover:bg-brand-700 px-3 py-2 rounded-lg text-sm transition"
                                title="Adicionar um número como admin em todos os grupos da campanha">
                                <UserPlus size={14} /> Adicionar Admin
                            </button>
                            <button onClick={() => { setGrupoNome(""); setModalGrupo(true); }} className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 px-3 py-2 rounded-lg text-sm transition">
                                <Plus size={14} /> Criar Grupo WA
                            </button>
                        </div>
                    </div>

                    {grupos.length === 0 ? (
                        <p className="text-ink-4 text-center py-10">Nenhum grupo vinculado</p>
                    ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                            {grupos.map((g, i) => (
                                <div key={g.id || i} className="bg-surface-1 border border-white/[0.06] rounded-lg p-4">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 rounded-full bg-surface-2 flex items-center justify-center text-lg flex-shrink-0">
                                            {g.foto_url ? <img src={g.foto_url} className="w-full h-full rounded-full object-cover" /> : "👥"}
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <p className="font-medium truncate">{g.nome_grupo}</p>
                                            <div className="flex items-center gap-2 mt-0.5">
                                                <p className="text-xs text-ink-4">{g.total_membros || 0}/{campanha?.limite_membros || 200} membros</p>
                                                <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${g.status === 'lotado' ? 'bg-red-900/50 text-red-400' :
                                                    g.status === 'inativo' ? 'bg-surface-3 text-ink-3' :
                                                        'bg-emerald-900/50 text-emerald-400'
                                                    }`}>{g.status || 'ativo'}</span>
                                            </div>
                                        </div>
                                        {g.invite_link && (
                                            <a href={g.invite_link} target="_blank" rel="noopener noreferrer"
                                                className="p-1.5 rounded hover:bg-surface-2 text-ink-4 hover:text-emerald-400 transition flex-shrink-0"
                                                title="Abrir link de convite">
                                                <ExternalLink size={14} />
                                            </a>
                                        )}
                                        <button
                                            onClick={async () => {
                                                if (!confirm(`Desvincular "${g.nome_grupo}" desta campanha?`)) return;
                                                try {
                                                    await desvincularGrupoService(campanhaId, g.id);
                                                    toast.success(`"${g.nome_grupo}" desvinculado`);
                                                    carregar();
                                                } catch { toast.error("Erro ao desvincular"); }
                                            }}
                                            className="p-1.5 rounded hover:bg-red-900/50 text-ink-4 hover:text-red-400 transition flex-shrink-0"
                                            title="Desvincular grupo">
                                            <Trash2 size={14} />
                                        </button>
                                    </div>
                                    {g.descricao && <p className="text-xs text-ink-3 mt-2 line-clamp-2">{g.descricao}</p>}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* === ABA SESSÕES (rotação multi-sessão) === */}
            {aba === "sessoes" && (
                <div>
                    <div className="flex flex-wrap justify-between items-center gap-2 mb-2">
                        <h2 className="text-lg font-semibold">Sessões de envio</h2>
                        {campSessoes.subsessoes.length > 0 && (
                            <button onClick={prepararSubsessoes}
                                className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 px-3 py-2 rounded-lg text-sm transition"
                                title="A sessão principal adiciona e promove as subsessões a admin em todos os grupos (lento, anti-ban)">
                                <UserPlus size={14} /> Preparar Subsessões
                            </button>
                        )}
                    </div>
                    <p className="text-xs text-ink-4 mb-4 max-w-2xl">
                        Com subsessões <b>preparadas</b> (admin nos grupos), o envio distribui os grupos entre as sessões
                        e roda em paralelo — cada sessão mantém seu próprio ritmo anti-ban, então a campanha termina
                        proporcionalmente mais rápido. Grupos onde a subsessão ainda não é admin caem na principal.
                    </p>

                    {/* Sessão principal */}
                    <div className="bg-surface-1 border border-emerald-800/60 rounded-lg p-4 mb-3 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-emerald-900/40 flex items-center justify-center flex-shrink-0">
                            <Smartphone size={18} className="text-emerald-400" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                                <p className="font-medium truncate">{campanha?.session_name || "—"}</p>
                                <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-emerald-900/50 text-emerald-400 font-medium">principal</span>
                            </div>
                            <p className="text-xs text-ink-4 mt-0.5">Envia em todos os {campSessoes.total_grupos || grupos.length} grupos e executa a preparação das subsessões</p>
                        </div>
                    </div>

                    {/* Subsessões */}
                    {campSessoes.subsessoes.length === 0 ? (
                        <p className="text-ink-4 text-sm py-4">Nenhuma subsessão configurada — o envio usa só a sessão principal.</p>
                    ) : (
                        <div className="space-y-3 mb-4">
                            {campSessoes.subsessoes.map((s) => {
                                const totalG = campSessoes.total_grupos || grupos.length || 0;
                                const pct = totalG ? Math.round((s.grupos_admin / totalG) * 100) : 0;
                                const conectada = s.sessao_status === "conectado" || s.sessao_status === "open";
                                return (
                                    <div key={s.session_name} className="bg-surface-1 border border-white/[0.06] rounded-lg p-4">
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 rounded-full bg-surface-2 flex items-center justify-center flex-shrink-0">
                                                <Smartphone size={18} className={conectada ? "text-emerald-400" : "text-red-400"} />
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <div className="flex items-center gap-2 flex-wrap">
                                                    <p className="font-medium truncate">{s.session_name}</p>
                                                    {s.numero && <span className="text-xs text-ink-4">{s.numero}</span>}
                                                    {s.provider && <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-surface-2 text-ink-3">{s.provider}</span>}
                                                    <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${conectada ? "bg-emerald-900/50 text-emerald-400" : "bg-red-900/50 text-red-400"}`}>
                                                        {conectada ? "conectada" : (s.sessao_status || "desconectada")}
                                                    </span>
                                                </div>
                                                <div className="flex items-center gap-2 mt-1.5">
                                                    <div className="flex-1 bg-surface-2 rounded-full h-1.5 overflow-hidden max-w-[240px]">
                                                        <div className={`h-full rounded-full ${pct === 100 ? "bg-emerald-500" : "bg-amber-500"}`} style={{ width: `${pct}%` }} />
                                                    </div>
                                                    <span className="text-xs text-ink-3 tabular-nums">
                                                        admin em {s.grupos_admin}/{totalG} grupos
                                                        {s.grupos_membro > 0 && ` · ${s.grupos_membro} sem promoção`}
                                                        {s.grupos_erro > 0 && ` · ${s.grupos_erro} erro(s)`}
                                                    </span>
                                                </div>
                                            </div>
                                            <button onClick={() => removerSubsessao(s.session_name)}
                                                className="p-1.5 rounded hover:bg-red-900/50 text-ink-4 hover:text-red-400 transition flex-shrink-0"
                                                title="Remover da rotação">
                                                <Trash2 size={14} />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Adicionar subsessão */}
                    <div className="bg-surface-1/50 border border-white/[0.06] rounded-lg p-4 max-w-xl">
                        <label className="text-sm text-ink-3 block mb-2">Adicionar subsessão (sessões conectadas da empresa)</label>
                        <div className="flex gap-2">
                            <select value={novaSubsessao} onChange={(e) => setNovaSubsessao(e.target.value)}
                                className="flex-1 bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-500">
                                <option value="">Selecionar...</option>
                                {sessoes
                                    .filter(s => s.session_name !== campanha?.session_name)
                                    .filter(s => !campSessoes.subsessoes.some(cs => cs.session_name === s.session_name))
                                    .map(s => (
                                        <option key={s.session_name} value={s.session_name}>
                                            {s.session_name}{s.numero ? ` · ${s.numero}` : ""}{s.provider ? ` · ${s.provider}` : ""}
                                        </option>
                                    ))}
                            </select>
                            <button onClick={adicionarSubsessao} disabled={!novaSubsessao}
                                className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 px-3 py-2 rounded-lg text-sm transition disabled:opacity-50">
                                <Plus size={14} /> Adicionar
                            </button>
                        </div>
                        <p className="text-xs text-ink-5 mt-2">
                            Depois de adicionar, rode <b>Preparar Subsessões</b>: a principal adiciona e promove cada uma a admin
                            nos grupos, com ritmo lento (~2 min por grupo) pra evitar bloqueio. Pode levar horas — é retomável.
                        </p>
                    </div>
                </div>
            )}

            {/* === ABA MENSAGENS === */}
            {aba === "mensagens" && (
                <div>
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-lg font-semibold">Mensagens da campanha</h2>
                        <button onClick={() => { setEditandoMsg(null); setMsgForm({ titulo: "", tipo: "texto", conteudo: "", media_url: "", mencao_todos: false, global: false, pollQuestion: "", pollOptions: "" }); setModalMsg(true); }} className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 px-3 py-2 rounded-lg text-sm transition">
                            <Plus size={14} /> Nova Mensagem
                        </button>
                    </div>

                    {mensagens.length === 0 ? (
                        <p className="text-ink-4 text-center py-10">Nenhuma mensagem cadastrada</p>
                    ) : (
                        <div className="space-y-3">
                            {mensagens.map((m) => (
                                <div key={m.id} className="bg-surface-1 border border-white/[0.06] rounded-lg p-4 flex items-center justify-between gap-4">
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-2 mb-1">
                                            <h3 className="font-medium truncate">{m.titulo}</h3>
                                            <span className={`text-xs px-2 py-0.5 rounded-full ${m.tipo === "texto" ? "bg-blue-900/50 text-blue-400" :
                                                m.tipo === "imagem" ? "bg-green-900/50 text-green-400" :
                                                    m.tipo === "video" ? "bg-brand-900/50 text-brand-400" :
                                                        m.tipo === "audio" ? "bg-accent-violet/15 text-accent-violet ring-1 ring-accent-violet/25" :
                                                            "bg-yellow-900/50 text-yellow-400"
                                                }`}>
                                                {m.tipo}
                                            </span>
                                            {m.mencao_todos && <span className="text-xs bg-red-900/50 text-red-400 px-2 py-0.5 rounded-full">@todos</span>}
                                        </div>
                                        <p className="text-sm text-ink-3 truncate">{m.conteudo || "(sem conteúdo)"}</p>
                                    </div>
                                    <div className="flex gap-1 flex-shrink-0">
                                        <button onClick={() => enviarMsg(m)} disabled={sendingMsgId !== null}
                                            className={`p-2 rounded hover:bg-surface-2 transition ${sendingMsgId === m.id ? 'text-amber-400 animate-pulse' : 'text-ink-3 hover:text-emerald-400'} disabled:opacity-50`}
                                            title={sendingMsgId === m.id ? 'Enviando...' : 'Enviar agora'}>
                                            {sendingMsgId === m.id ? <span className="animate-spin inline-block">⏳</span> : <Send size={14} />}
                                        </button>
                                        <button onClick={() => editarMsg(m)} className="p-2 rounded hover:bg-surface-2 text-ink-3 hover:text-blue-400 transition" title="Editar">
                                            <Edit2 size={14} />
                                        </button>
                                        <button onClick={async () => { await deleteMensagemService(m.id); toast.success("Excluída"); carregar(); }} className="p-2 rounded hover:bg-surface-2 text-ink-3 hover:text-red-400 transition" title="Excluir">
                                            <Trash2 size={14} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* === ABA AGENDAMENTOS === */}
            {aba === "agendamentos" && (
                <div>
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-lg font-semibold">Agendamentos</h2>
                        <button onClick={() => setModalAgenda(true)} className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 px-3 py-2 rounded-lg text-sm transition">
                            <Plus size={14} /> Novo Agendamento
                        </button>
                    </div>

                    {agendamentos.length === 0 ? (
                        <p className="text-ink-4 text-center py-10">Nenhum agendamento</p>
                    ) : (
                        <div className="space-y-3">
                            {agendamentos.map((a) => (
                                <div key={a.id} className="bg-surface-1 border border-white/[0.06] rounded-lg p-4 flex items-center justify-between gap-4">
                                    <div className="flex items-center gap-3">
                                        <Calendar size={16} className="text-ink-4" />
                                        <div>
                                            <p className="font-medium">{a.mensagem_titulo}</p>
                                            <p className="text-xs text-ink-3">
                                                {a.data_hora ? format(new Date(a.data_hora), "dd/MM/yyyy HH:mm") : "-"}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <span className={`text-xs px-2 py-1 rounded-full ${a.status === "pendente" ? "bg-yellow-900/50 text-yellow-400" :
                                            a.status === "enviado" ? "bg-emerald-900/50 text-emerald-400" :
                                                "bg-red-900/50 text-red-400"
                                            }`}>
                                            {a.status}
                                        </span>
                                        {a.status === "pendente" && (
                                            <button onClick={async () => {
                                                const confirm = await Swal.fire({
                                                    title: 'Cancelar agendamento?',
                                                    text: `Deseja cancelar o envio de "${a.mensagem_titulo}"?`,
                                                    icon: 'warning', showCancelButton: true,
                                                    confirmButtonColor: '#ef4444', confirmButtonText: 'Sim, cancelar',
                                                    cancelButtonText: 'Não',
                                                });
                                                if (!confirm.isConfirmed) return;
                                                await deleteAgendamentoService(a.id);
                                                toast.success("Agendamento cancelado");
                                                carregar();
                                            }} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-red-900/30 text-red-400 hover:bg-red-900/60 text-xs font-medium transition">
                                                <Trash2 size={12} /> Cancelar
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* === ABA LOGS === */}
            {aba === "logs" && (
                <div>
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-lg font-semibold">Logs de Operações</h2>
                        <button onClick={async () => { try { setLogs(await loadLogsService(campanhaId)); toast.success('Logs atualizados'); } catch { toast.error('Erro'); } }}
                            className="flex items-center gap-2 bg-surface-2 hover:bg-surface-3 px-3 py-2 rounded-lg text-sm transition">
                            <RefreshCw size={14} /> Atualizar
                        </button>
                    </div>

                    {logs.length === 0 ? (
                        <p className="text-ink-4 text-center py-10">Nenhum log registrado</p>
                    ) : (
                        <div className="space-y-2">
                            {logs.map((log) => {
                                const statusBadge = {
                                    processando: 'bg-yellow-900/50 text-yellow-400',
                                    concluido: 'bg-emerald-900/50 text-emerald-400',
                                    parcial: 'bg-orange-900/50 text-orange-400',
                                    erro: 'bg-red-900/50 text-red-400',
                                }[log.status] || 'bg-surface-2 text-ink-3';
                                const tipoLabel = {
                                    envio: '📨 Envio de Mensagem',
                                    envio_agendado: '📅 Envio Agendado',
                                    criacao: '➕ Criação de Grupos',
                                    edicao_massa: '✏️ Edição em Massa',
                                    revalidacao: '🔄 Revalidação de Membros',
                                    sincronizacao: '🔃 Sincronização de Membros',
                                    preparar_sessoes: '📱 Preparação de Subsessões',
                                }[log.tipo] || log.tipo;
                                const isExpanded = expandedLog === log.id;
                                const detalhes = Array.isArray(log.detalhes) ? log.detalhes : [];

                                return (
                                    <div key={log.id} className="bg-surface-1 border border-white/[0.06] rounded-lg overflow-hidden">
                                        <button onClick={() => setExpandedLog(isExpanded ? null : log.id)}
                                            className="w-full flex items-center justify-between p-4 text-left hover:bg-surface-2/50 transition">
                                            <div className="flex items-center gap-3 flex-1 min-w-0">
                                                <span className="text-sm font-medium truncate">{tipoLabel}</span>
                                                <span className={`text-xs px-2 py-0.5 rounded-full flex-shrink-0 ${statusBadge}`}>
                                                    {log.status === 'processando' ? '⏳ Processando' : log.status}
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-4 text-xs text-ink-3 flex-shrink-0">
                                                <span className="text-emerald-400">✅ {log.ok}</span>
                                                {log.erros > 0 && <span className="text-red-400">❌ {log.erros}</span>}
                                                <span>/ {log.total}</span>
                                                <span>{log.iniciado_em ? format(new Date(log.iniciado_em), 'dd/MM HH:mm') : '-'}</span>
                                                {isExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                                            </div>
                                        </button>
                                        {isExpanded && detalhes.length > 0 && (
                                            <div className="border-t border-white/[0.06] p-4 max-h-[400px] overflow-y-auto">
                                                <div className="space-y-3">
                                                    {detalhes.map((d, idx) => {
                                                        const hasAcoes = Array.isArray(d.acoes) && d.acoes.length > 0;
                                                        const grupoTemErro = hasAcoes ? d.acoes.some(a => a.status === 'erro') : d.status === 'erro';
                                                        const grupoIcon = grupoTemErro ? '❌' : d.status === 'ja_membro' ? '⚠️' : '✅';

                                                        return (
                                                            <div key={idx} className="bg-surface-2/50 rounded-lg p-3">
                                                                {/* Grupo header */}
                                                                <div className="flex items-center justify-between mb-1">
                                                                    <div className="flex items-center gap-2">
                                                                        <span>{grupoIcon}</span>
                                                                        <span className="text-sm font-medium text-ink-2">{d.grupo}</span>
                                                                    </div>
                                                                    <span className="text-[10px] text-ink-4">
                                                                        {d.timestamp ? format(new Date(d.timestamp), 'dd/MM HH:mm:ss') : ''}
                                                                    </span>
                                                                </div>

                                                                {/* Sub-operações */}
                                                                {hasAcoes && (
                                                                    <div className="ml-6 mt-1 space-y-0.5">
                                                                        {d.acoes.map((a, ai) => (
                                                                            <div key={ai} className="flex items-start gap-2 text-xs">
                                                                                <span className={a.status === 'erro' ? 'text-red-400' : a.status === 'ja_membro' ? 'text-yellow-400' : 'text-emerald-400'}>
                                                                                    {a.status === 'erro' ? '✗' : a.status === 'ja_membro' ? '~' : '✓'}
                                                                                </span>
                                                                                <span className="text-ink-3 flex-shrink-0">{a.acao || a.campo || '-'}</span>
                                                                                {a.numero && <span className="text-ink-4">{a.numero}</span>}
                                                                                {a.de && a.para && <span className="text-ink-4">{a.de} → {a.para}</span>}
                                                                                {!a.de && a.para && <span className="text-ink-4">→ {a.para}</span>}
                                                                                {a.msg && <span className="text-red-400/70 truncate" title={a.msg}>({a.msg})</span>}
                                                                                {a.hora && <span className="text-ink-5 ml-auto flex-shrink-0">{format(new Date(a.hora), 'HH:mm:ss')}</span>}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}

                                                                {/* Formato antigo sem acoes */}
                                                                {!hasAcoes && d.msg && (
                                                                    <p className="ml-6 text-xs text-red-400/70 mt-1">{d.msg}</p>
                                                                )}
                                                                {!hasAcoes && !d.acoes && d.status && (
                                                                    <p className="ml-6 text-xs text-ink-4 mt-1">{d.status}</p>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {log.finalizado_em && (
                                                    <p className="text-xs text-ink-4 mt-3 pt-2 border-t border-white/[0.06]">
                                                        Finalizado em {format(new Date(log.finalizado_em), 'dd/MM/yyyy HH:mm:ss')}
                                                    </p>
                                                )}
                                            </div>
                                        )}
                                        {isExpanded && detalhes.length === 0 && (
                                            <div className="border-t border-white/[0.06] p-4 text-xs text-ink-4 text-center">
                                                {log.status === 'processando' ? 'Aguardando... Detalhes aparecerão em breve.' : 'Sem detalhes registrados.'}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}

            {/* === MODAL CRIAR GRUPO === */}
            {modalGrupo && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                    <div className="bg-surface-1 rounded-xl border border-white/[0.08] p-6 w-full max-w-sm">
                        <h2 className="text-lg font-bold mb-2">Criar Grupo(s) WhatsApp</h2>
                        <p className="text-xs text-ink-4 mb-4">
                            Admins, espiões, foto e descrição serão aplicados da configuração da campanha.
                        </p>
                        <div className="space-y-3">
                            <div>
                                <label className="text-sm text-ink-3 block mb-1">Nome base do grupo *</label>
                                <input value={grupoNome} onChange={(e) => setGrupoNome(e.target.value)}
                                    className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-500" placeholder="Ex: Lives Fórum Telecom" />
                            </div>
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <label className="text-sm text-ink-3 block mb-1">Quantidade</label>
                                    <input type="number" min="1" max="50" value={grupoQtd}
                                        onChange={(e) => setGrupoQtd(Math.max(1, parseInt(e.target.value) || 1))}
                                        className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-500" />
                                </div>
                                <div>
                                    <label className="text-sm text-ink-3 block mb-1">Número inicial</label>
                                    <input type="number" min="1" value={grupoNumInicial}
                                        onChange={(e) => setGrupoNumInicial(Math.max(1, parseInt(e.target.value) || 1))}
                                        className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-500" />
                                </div>
                            </div>
                            {/* Preview */}
                            {grupoNome.trim() && (
                                <div className="bg-surface-2/50 border border-white/[0.08] rounded-lg p-3 text-xs text-ink-3">
                                    <p className="font-medium text-ink-2 mb-1">👁 Preview:</p>
                                    {grupoQtd > 1 ? (
                                        <>
                                            <p>{grupoNome} #{grupoNumInicial}</p>
                                            {grupoQtd > 2 && <p className="text-ink-5">...</p>}
                                            <p>{grupoNome} #{grupoNumInicial + grupoQtd - 1}</p>
                                            <p className="mt-1 text-ink-4">{grupoQtd} grupo(s) • ~{Math.ceil(grupoQtd * 15 / 60)} min</p>
                                        </>
                                    ) : (
                                        <p>{grupoNome}</p>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="mt-3 text-xs text-ink-4 space-y-1">
                            {campanha?.session_name && <p>📱 Sessão: <strong className="text-ink-2">{campanha.session_name}</strong></p>}
                            {campanha?.admins?.length > 0 && <p>👑 Admins: {campanha.admins.length}</p>}
                            {campanha?.espioes?.length > 0 && <p>👁 Espiões: {campanha.espioes.length}</p>}
                            {campanha?.imagem_url && <p>🖼 Foto da campanha será aplicada</p>}
                        </div>
                        <div className="flex justify-end gap-2 mt-6">
                            <button onClick={() => setModalGrupo(false)} className="px-4 py-2 rounded-lg bg-surface-2 hover:bg-surface-3 text-sm transition">Cancelar</button>
                            <button onClick={criarGrupo} className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-sm font-medium transition">
                                {grupoQtd > 1 ? `Criar ${grupoQtd} Grupos` : 'Criar Grupo'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* === MODAL IMPORTAR GRUPOS === */}
            {modalImportar && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                    <div className="bg-surface-1 rounded-xl border border-white/[0.08] p-6 w-full max-w-lg max-h-[85vh] flex flex-col">
                        <h2 className="text-lg font-bold mb-1">Importar Grupos</h2>
                        <p className="text-xs text-ink-4 mb-3">
                            Grupos do WhatsApp ainda não vinculados a nenhuma campanha. Sessão: <strong className="text-ink-2">{sessionName}</strong>
                        </p>

                        {/* Busca */}
                        <div className="relative mb-3">
                            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-4" />
                            <input
                                value={buscaGrupo}
                                onChange={(e) => setBuscaGrupo(e.target.value)}
                                className="w-full bg-surface-2 border border-white/[0.08] rounded-lg pl-9 pr-3 py-2 text-sm focus:outline-none focus:border-emerald-500"
                                placeholder="Buscar grupo..."
                            />
                        </div>

                        {/* Lista */}
                        <div className="flex-1 overflow-y-auto space-y-2 min-h-0">
                            {loadingImport ? (
                                <div className="flex justify-center py-10">
                                    <div className="animate-spin h-6 w-6 border-2 border-emerald-500 border-t-transparent rounded-full" />
                                </div>
                            ) : gruposFiltrados.length === 0 ? (
                                <p className="text-ink-4 text-center py-10 text-sm">
                                    {gruposDisponiveis.length === 0 ? "Nenhum grupo disponível para importar" : "Nenhum resultado para a busca"}
                                </p>
                            ) : (
                                gruposFiltrados.map((g) => (
                                    <div
                                        key={g.grupo_jid}
                                        onClick={() => toggleSelection(g.grupo_jid)}
                                        className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition border ${gruposSelecionados.includes(g.grupo_jid)
                                            ? "border-emerald-600 bg-emerald-950/30"
                                            : "border-white/[0.06] bg-surface-1 hover:border-white/[0.08]"
                                            }`}
                                    >
                                        <div className={`w-5 h-5 rounded border flex items-center justify-center flex-shrink-0 ${gruposSelecionados.includes(g.grupo_jid)
                                            ? "border-emerald-500 bg-emerald-600"
                                            : "border-white/[0.12]"
                                            }`}>
                                            {gruposSelecionados.includes(g.grupo_jid) && <Check size={12} />}
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <p className="font-medium text-sm truncate">{g.nome_grupo}</p>
                                            <p className="text-xs text-ink-4">{g.total_membros} membros</p>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>

                        <div className="flex items-center justify-between mt-4 pt-3 border-t border-white/[0.06]">
                            <span className="text-xs text-ink-3">
                                {gruposSelecionados.length} selecionado(s)
                            </span>
                            <div className="flex gap-2">
                                <button onClick={() => setModalImportar(false)} className="px-4 py-2 rounded-lg bg-surface-2 hover:bg-surface-3 text-sm transition">Cancelar</button>
                                <button
                                    onClick={importarGrupos}
                                    disabled={gruposSelecionados.length === 0}
                                    className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-sm font-medium transition disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Importar ({gruposSelecionados.length})
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* === MODAL MENSAGEM === */}
            {modalMsg && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                    <div className="bg-surface-1 rounded-xl border border-white/[0.08] p-6 w-full max-w-md max-h-[90vh] overflow-y-auto">
                        <h2 className="text-lg font-bold mb-4">{editandoMsg ? "Editar Mensagem" : "Nova Mensagem"}</h2>
                        <div className="space-y-3">
                            <div>
                                <label className="text-sm text-ink-3 block mb-1">Título *</label>
                                <input value={msgForm.titulo} onChange={(e) => setMsgForm({ ...msgForm, titulo: e.target.value })}
                                    className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-500" />
                            </div>
                            <div>
                                <label className="text-sm text-ink-3 block mb-1">Tipo</label>
                                <select value={msgForm.tipo} onChange={(e) => setMsgForm({ ...msgForm, tipo: e.target.value })}
                                    className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm">
                                    <option value="texto">Texto</option>
                                    <option value="imagem">Imagem</option>
                                    <option value="video">Vídeo</option>
                                    <option value="audio">Áudio (voz)</option>
                                    <option value="enquete">Enquete</option>
                                </select>
                            </div>
                            {msgForm.tipo !== "enquete" && msgForm.tipo !== "audio" && (
                                <div>
                                    <label className="text-sm text-ink-3 block mb-1">{msgForm.tipo === "texto" ? "Mensagem" : "Caption"}</label>
                                    <textarea value={msgForm.conteudo} onChange={(e) => setMsgForm({ ...msgForm, conteudo: e.target.value })}
                                        className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm h-24 resize-none focus:outline-none focus:border-emerald-500" />
                                </div>
                            )}
                            {(msgForm.tipo === "imagem" || msgForm.tipo === "video" || msgForm.tipo === "audio") && (
                                <div>
                                    <label className="text-sm text-ink-3 block mb-1">
                                        {msgForm.tipo === 'video' ? 'Vídeo (máx 200MB)' : msgForm.tipo === 'audio' ? 'Áudio (voz, máx 16MB)' : 'Imagem'} *
                                    </label>
                                    <input ref={mediaFileRef} type="file"
                                        accept={msgForm.tipo === 'video' ? 'video/*' : msgForm.tipo === 'audio' ? 'audio/*' : 'image/*'}
                                        onChange={handleMediaUpload} className="hidden" />
                                    <div className="flex items-center gap-2">
                                        <button type="button" onClick={() => mediaFileRef.current?.click()}
                                            disabled={mediaUploading}
                                            className="flex items-center gap-2 bg-surface-2 border border-white/[0.08] hover:border-emerald-500 rounded-lg px-3 py-2 text-sm transition disabled:opacity-50">
                                            {mediaUploading ? <><span className="animate-spin">⏳</span> Enviando...</> : <><Upload size={14} /> Escolher arquivo</>}
                                        </button>
                                        {msgForm.media_url && <span className="text-xs text-emerald-400 truncate max-w-[200px]">✅ Enviado</span>}
                                    </div>
                                    {msgForm.media_url && (
                                        <div className="mt-2">
                                            {msgForm.tipo === 'imagem' ? (
                                                <img src={msgForm.media_url} alt="preview" className="w-20 h-20 rounded-lg object-cover border border-white/[0.08]" />
                                            ) : msgForm.tipo === 'audio' ? (
                                                <audio src={msgForm.media_url} className="w-full max-w-[280px]" controls />
                                            ) : (
                                                <video src={msgForm.media_url} className="w-32 h-20 rounded-lg border border-white/[0.08] object-cover" controls />
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                            {msgForm.tipo === "enquete" && (
                                <>
                                    <div>
                                        <label className="text-sm text-ink-3 block mb-1">Pergunta</label>
                                        <input value={msgForm.pollQuestion} onChange={(e) => setMsgForm({ ...msgForm, pollQuestion: e.target.value })}
                                            className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-500" />
                                    </div>
                                    <div>
                                        <label className="text-sm text-ink-3 block mb-1">Opções (separadas por vírgula)</label>
                                        <input value={msgForm.pollOptions} onChange={(e) => setMsgForm({ ...msgForm, pollOptions: e.target.value })}
                                            className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-500" placeholder="Sim, Não, Talvez" />
                                    </div>
                                </>
                            )}
                            <div className="flex gap-4">
                                <label className="flex items-center gap-2 text-sm">
                                    <input type="checkbox" checked={msgForm.mencao_todos} onChange={(e) => setMsgForm({ ...msgForm, mencao_todos: e.target.checked })} className="rounded" />
                                    <span className="text-ink-3">@todos</span>
                                </label>
                                <label className="flex items-center gap-2 text-sm">
                                    <input type="checkbox" checked={msgForm.global} onChange={(e) => setMsgForm({ ...msgForm, global: e.target.checked })} className="rounded" />
                                    <span className="text-ink-3">Global</span>
                                </label>
                            </div>
                        </div>
                        <div className="flex justify-end gap-2 mt-6">
                            <button onClick={() => { setModalMsg(false); setEditandoMsg(null); }} className="px-4 py-2 rounded-lg bg-surface-2 hover:bg-surface-3 text-sm transition">Cancelar</button>
                            <button onClick={salvarMsg} className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-sm font-medium transition">
                                {editandoMsg ? "Salvar" : "Criar"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* === MODAL AGENDAMENTO === */}
            {modalAgenda && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                    <div className="bg-surface-1 rounded-xl border border-white/[0.08] p-6 w-full max-w-md">
                        <h2 className="text-lg font-bold mb-4">Novo Agendamento</h2>
                        <div className="space-y-3">
                            <div>
                                <label className="text-sm text-ink-3 block mb-1">Mensagem</label>
                                <select value={agendaForm.mensagem_id} onChange={(e) => setAgendaForm({ ...agendaForm, mensagem_id: e.target.value })}
                                    className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm">
                                    <option value="">Selecionar...</option>
                                    {mensagens.map((m) => <option key={m.id} value={m.id}>{m.titulo} ({m.tipo})</option>)}
                                </select>
                            </div>
                            <div>
                                <label className="text-sm text-ink-3 block mb-1">Data e Hora</label>
                                <input type="datetime-local" value={agendaForm.data_hora} onChange={(e) => setAgendaForm({ ...agendaForm, data_hora: e.target.value })}
                                    className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-500" />
                            </div>
                            <div>
                                <label className="text-sm text-ink-3 block mb-1">Grupos ({agendaForm.grupos_alvo.length > 0 ? agendaForm.grupos_alvo.length : grupos.length} selecionados)</label>
                                <div className="bg-surface-2 border border-white/[0.08] rounded-lg p-2 max-h-48 overflow-y-auto">
                                    <label className="flex items-center gap-2 p-1.5 hover:bg-surface-3/50 rounded cursor-pointer border-b border-white/[0.08] mb-1 pb-2">
                                        <input type="checkbox"
                                            checked={agendaForm.grupos_alvo.length === 0 || agendaForm.grupos_alvo.length === grupos.length}
                                            onChange={(e) => setAgendaForm({ ...agendaForm, grupos_alvo: e.target.checked ? [] : [] })}
                                            className="accent-emerald-500" />
                                        <span className="text-xs font-semibold">Todos os grupos ({grupos.length})</span>
                                    </label>
                                    {grupos.map((g) => {
                                        const isSelected = agendaForm.grupos_alvo.length === 0 || agendaForm.grupos_alvo.includes(g.grupo_jid);
                                        return (
                                            <label key={g.grupo_jid} className="flex items-center gap-2 p-1.5 hover:bg-surface-3/50 rounded cursor-pointer">
                                                <input type="checkbox" checked={isSelected}
                                                    onChange={(e) => {
                                                        let current = agendaForm.grupos_alvo.length === 0 ? grupos.map(x => x.grupo_jid) : [...agendaForm.grupos_alvo];
                                                        if (e.target.checked) {
                                                            current = [...current, g.grupo_jid];
                                                        } else {
                                                            current = current.filter(j => j !== g.grupo_jid);
                                                        }
                                                        setAgendaForm({ ...agendaForm, grupos_alvo: current.length === grupos.length ? [] : current });
                                                    }}
                                                    className="accent-emerald-500" />
                                                <span className="text-xs truncate">{g.nome_grupo}</span>
                                            </label>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end gap-2 mt-6">
                            <button onClick={() => { setModalAgenda(false); setAgendaForm({ mensagem_id: '', data_hora: '', grupos_alvo: [] }); }} className="px-4 py-2 rounded-lg bg-surface-2 hover:bg-surface-3 text-sm transition">Cancelar</button>
                            <button onClick={agendar} className="px-4 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-sm font-medium transition">Agendar</button>
                        </div>
                    </div>
                </div>
            )}

            {/* === MODAL EDIÇÃO EM MASSA === */}
            {modalBulkEdit && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
                    <div className="bg-surface-1 rounded-xl border border-white/[0.08] p-6 w-full max-w-md">
                        <h2 className="text-lg font-bold mb-1">Editar Grupos em Massa</h2>
                        <p className="text-xs text-ink-4 mb-4">{grupos.length} grupo(s) serão editados. Delay de 3s entre cada grupo.</p>
                        <div className="space-y-3">
                            <div>
                                <label className="text-sm text-ink-3 block mb-1">Novo Nome (Subject)</label>
                                <input
                                    value={bulkForm.subject}
                                    onChange={(e) => setBulkForm({ ...bulkForm, subject: e.target.value })}
                                    placeholder="Ex: Lives Fórum Telecom"
                                    className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-amber-500"
                                />
                                <p className="text-xs text-ink-5 mt-1">Numeração #N será adicionada automaticamente</p>
                            </div>
                            {bulkForm.subject.trim() && (
                                <div className="flex items-center gap-3">
                                    <div className="flex-1">
                                        <label className="text-sm text-ink-3 block mb-1">Número inicial</label>
                                        <input type="number" min="1"
                                            value={bulkForm.numeroInicial}
                                            onChange={(e) => setBulkForm({ ...bulkForm, numeroInicial: Math.max(1, parseInt(e.target.value) || 1) })}
                                            className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-amber-500"
                                        />
                                    </div>
                                    <div className="flex-1 bg-surface-2/50 border border-white/[0.08] rounded-lg p-2 text-xs text-ink-3">
                                        <p className="font-medium text-ink-2 mb-0.5">👁 Preview:</p>
                                        <p>{bulkForm.subject} #{bulkForm.numeroInicial}</p>
                                        {grupos.length > 2 && <p className="text-ink-5">...</p>}
                                        {grupos.length > 1 && <p>{bulkForm.subject} #{(bulkForm.numeroInicial || 1) + grupos.length - 1}</p>}
                                    </div>
                                </div>
                            )}
                            <div>
                                <label className="text-sm text-ink-3 block mb-1">Descrição</label>
                                <textarea
                                    value={bulkForm.description}
                                    onChange={(e) => setBulkForm({ ...bulkForm, description: e.target.value })}
                                    rows={3}
                                    placeholder="Deixe vazio para não alterar"
                                    className="w-full bg-surface-2 border border-white/[0.08] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-amber-500 resize-none"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-ink-3 block mb-1">Foto do Grupo</label>
                                <input ref={bulkFileRef} type="file" accept="image/*" onChange={handleBulkPhotoUpload} className="hidden" />
                                <div className="flex items-center gap-2">
                                    <button type="button" onClick={() => bulkFileRef.current?.click()}
                                        disabled={bulkUploading}
                                        className="flex items-center gap-2 bg-surface-2 border border-white/[0.08] hover:border-amber-500 rounded-lg px-3 py-2 text-sm transition disabled:opacity-50">
                                        {bulkUploading ? <><span className="animate-spin">⏳</span> Enviando...</> : <><Upload size={14} /> Escolher foto</>}
                                    </button>
                                    {bulkForm.imageUrl && <span className="text-xs text-emerald-400">✅ Foto selecionada</span>}
                                </div>
                                {bulkForm.imageUrl && (
                                    <img src={bulkForm.imageUrl} alt="preview" className="w-16 h-16 rounded-lg object-cover mt-2 border border-white/[0.08]" onError={(e) => e.target.style.display = 'none'} />
                                )}
                            </div>

                            {/* Separador */}
                            <div className="border-t border-white/[0.06] my-1"></div>

                            {/* Revalidar admins/espiões */}
                            <label className="flex items-center gap-3 cursor-pointer bg-surface-2/50 border border-white/[0.08] rounded-lg p-3 hover:border-amber-500/50 transition">
                                <input type="checkbox" checked={bulkForm.revalidar}
                                    onChange={(e) => setBulkForm({ ...bulkForm, revalidar: e.target.checked })}
                                    className="rounded accent-amber-500" />
                                <div>
                                    <div className="text-sm font-medium flex items-center gap-2">
                                        <RefreshCw size={14} className="text-amber-400" />
                                        Revalidar Admins e Espiões
                                    </div>
                                    <p className="text-xs text-ink-4 mt-0.5">
                                        Adiciona e promove admins/espiões em todos os grupos
                                    </p>
                                </div>
                            </label>
                        </div>
                        <div className="flex justify-end gap-2 mt-6">
                            <button onClick={() => setModalBulkEdit(false)} className="px-4 py-2 rounded-lg bg-surface-2 hover:bg-surface-3 text-sm transition" disabled={bulkLoading}>Cancelar</button>
                            <button onClick={executarBulkEdit} disabled={bulkLoading} className="px-4 py-2 rounded-lg bg-amber-600 hover:bg-amber-700 text-sm font-medium transition disabled:opacity-50 flex items-center gap-2">
                                {bulkLoading ? (
                                    <><span className="animate-spin">⏳</span> Editando...</>
                                ) : (
                                    <><Settings size={14} /> Aplicar em Todos</>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </main>
    );
}
